import React from 'react';

import Icon, { IconTypes } from 'components/basic/Icon';

export const providersButtons = {
  apple: {
    text: 'Apple ID',
    img: <Icon icon={IconTypes.apple} size={24} color="--ink" />,
  },
  google: {
    text: 'Google',
    img: <Icon icon={IconTypes.google} size={24} />,
  },
  facebook: {
    text: 'Facebook',
    img: <Icon icon={IconTypes.facebook} size={24} />,
  },
};
